(function(){
  'use strict';
  var offer=window.MonobloccOffer;
  if(!offer)return;
  var offset=0;
  var last=null;
  function paint(){
    var active=offer.active(Date.now()+offset);
    var banner=document.getElementById('silver-week-banner');
    if(banner)banner.hidden=!active;
    document.querySelectorAll('[data-sw-price]').forEach(function(node){
      var label=node.querySelector('[data-sw-amount]');
      if(!label){
        label=document.createElement('div');label.dataset.swAmount='';
        label.style.cssText='font-size:20px;color:#07533f;font-weight:700;margin-top:8px';
        node.appendChild(label);
      }
      var regular=Number(node.dataset.swPrice);
      var text='シルバーウィーク10%OFF：¥'+Math.round(regular*0.9).toLocaleString('ja-JP')+(node.dataset.swVaries==='true'?'〜':'')+'（税込）';
      if(label.textContent!==text)label.textContent=text;
      label.hidden=!active;
    });
    if(last!==null&&last!==active&&!active&&location.pathname==='/cart')location.reload();
    last=active;
  }
  function sync(){fetch(location.pathname+'?sw_clock='+Date.now(),{method:'HEAD',cache:'no-store'}).then(function(r){var server=Date.parse(r.headers.get('Date'));if(Number.isFinite(server))offset=server-Date.now();paint();}).catch(paint);}
  paint();sync();
  setInterval(paint,1000);
  document.addEventListener('visibilitychange',function(){if(!document.hidden)sync();});
})();
